'use client'

import {ErrorPageLayout} from '@/components/error/ErrorPageLayout'

import {RequestScopedProviders} from './providers/RequestScopedProviders'

/*
 * The 404 for everything under [locale]. A client component because Next renders a boundary into
 * every page beneath it: a server one reading the locale would stop the (static) group prerendering.
 * It replaces both groups' layouts, so it brings the request-free providers the (static) one would.
 * Which URL reaches which 404, and why: docs/not-found.md
 */
export default function NotFound() {
  return (
    <RequestScopedProviders request={null} prices={null}>
      <ErrorPageLayout statusCode={404} />
    </RequestScopedProviders>
  )
}
